import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { CostForm } from './CostForm';

type Props = ComponentProps<typeof CostForm>;

export const CostFormDrawer: FC<Props> = ({ initialValues, onSubmit }) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'cost'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <CostForm initialValues={initialValues} onSubmit={onSubmit} />
    </Drawer>
  );
};
